import { observer } from 'mobx-react-lite'
import { Box, Button } from 'shared/ui'
import { type UKComplianceModalStore } from '../store/UKComplianceModalStore'

export type UKComplianceModalActionsProps = {
  store: UKComplianceModalStore
}

export const UKComplianceModalActions = observer(({ store }: UKComplianceModalActionsProps) => {
  const { isAdminOrOwner, onGetApproved, onCloseModal } = store

  if (isAdminOrOwner) {
    return (
      <Box display='flex' gap={'8px'} width={'100%'}>
        <Button
          fullWidth
          typeBtn='contained'
          contained='secondary'
          text='Close'
          onClick={onCloseModal}
        />
        <Button fullWidth typeBtn='contained' text='Get approved' onClick={onGetApproved} />
      </Box>
    )
  }

  return <Button fullWidth typeBtn='contained' text='Got it' onClick={onCloseModal} />
})
